export default __webpack_public_path__ + "static/media/paintbrush.4022be88.cur";